import {
  ListItem,
  List,
  ListItemText,
  useTheme
} from '@mui/material';
import { useDispatch, useSelector } from 'src/store';
import { setSelectedIrrigation } from 'src/slices/charts';

interface Props {
  irrigation: any
}

const NavItem = ({ irrigation }: Props) => {
  const { selectedIrrigation } = useSelector((state) => state.charts_store)
  const dispatch = useDispatch()
  const theme = useTheme();

  const handleIrrigationClick = () => {
    dispatch(setSelectedIrrigation(irrigation))
  }

  return (
    <ListItem
      sx={{
        whiteSpace: 'nowrap',
        marginBottom: '5px',
        padding: '5px 5px',
        borderRadius: '8px',
        color: 'white',
        display: 'block',
        cursor: 'pointer',
        position: 'relative',
        paddingLeft: '10px',
        '&.Mui-selected': {
          backgroundColor: '#4E453C',
          color: theme.palette.warning.main
        },
        '&:hover': {
          backgroundColor: '#1A3551',
          fontWeight: "bold",
        },
      }}
      selected={selectedIrrigation?.irrigation_channel_network_id === irrigation.irrigation_channel_network_id}
      onClick={handleIrrigationClick}
    >
      <ListItemText>
        {irrigation.name}
      </ListItemText>
    </ListItem>
  );
}

export default NavItem